import error_404 from './404-error.png';
import about from './about.jpg';
import auth_offline from './auth-offline.gif';
import auth_one_bg from './auth-one-bg.jpg';
import avensys_header from './avensys-header.png';
import bg_auth from './bg-auth.jpg';
import bg_d from './bg-d.png';
import chat_bg_pattern from './chat-bg-pattern.png';
import coming_soon_img from './coming-soon-img.png';
import comingsoon from './comingsoon.png';
import cover_pattern from './cover-pattern.png';
import error from './error.svg';
import error400_cover from './error400-cover.png';
import error500 from './error500.png';
import faq_img from './faq-img.png';
import fav_icon from './fav_icon.png';
import file from './file.png';
import giftbox from './giftbox.png';
import illustrator_1 from './illustrator-1.png';
import job_profile2 from './job-profile2.png';
import logo_dark from './logo-dark.png';
import logo_light from './logo-light.png';
import logo_pulse from './logo-pulse.png';
import logo_sm_1 from './logo-sm-1.png';
import logo_sm from './logo-sm.png';
import logo_big from './logo_big.svg';
import mac_img from './mac-img.png';
import maintenance from './maintenance.png';
import modal_bg from './modal-bg.png';
import new_img from './new.png';
import profile_bg from './profile-bg.jpg';
import server_error from './server-error.png';
import sorting from './sorting.svg';
import task from './task.png';
import user_illustarator_1 from './user-illustarator-1.png';
import user_illustarator_2 from './user-illustarator-2.png';
import verification_img from './verification-img.png';
import widget_img from './widget-img.png';
import job_active from './job-active.png';
import job_inactive from './job-inactive.png';
import favicon_jp from './favicon_jp.png';
import avensys_full_logo from './avensys_full_logo.png'
import sparkle from './sparkle.png';
import * as icons from './icons';
import pulse_logo from './pulse-logo.png';
import pulse_logo_mini from './pulse-logo-mini.png';

export {
  error_404,
  about,
  auth_offline,
  auth_one_bg,
  avensys_header,
  bg_auth,
  bg_d,
  chat_bg_pattern,
  coming_soon_img,
  comingsoon,
  cover_pattern,
  error,
  error400_cover,
  error500,
  faq_img,
  fav_icon,
  file,
  giftbox,
  illustrator_1,
  job_profile2,
  logo_dark,
  logo_light,
  logo_pulse,
  logo_sm_1,
  logo_sm,
  logo_big,
  mac_img,
  maintenance,
  modal_bg,
  new_img,
  profile_bg,
  server_error,
  sorting,
  task,
  user_illustarator_1,
  user_illustarator_2,
  verification_img,
  widget_img,
  icons,
  job_active,
  job_inactive,
  favicon_jp,
  avensys_full_logo,
  sparkle
};